<template>
    <div>
    <span v-if="itemLote.negociacao.aceito === null" class="ml-3" @click.native.stop>
        <v-icon class="ml-1 icone-negociacao" color="#4A9246" left @click.stop.prevent>far fa-handshake</v-icon>
        <span class="negociacao-solicitada" @click.stop.prevent>Negociação Solicitada:&nbsp;</span>

        <v-tooltip top v-if="itemLote.negociacao && itemLote.negociacao.mensagem" @click.native.stop>
            <a slot="activator" class="link-icone-mensagem">
                <v-icon size="15px" left class="ml-1 icone-mensagem-negociacao">fas fa-comment</v-icon>
            </a>
            {{ itemLote.negociacao.mensagem }}
        </v-tooltip>

        <v-chip color="#e8e8e8" class="money-chip">
            <az-money v-model="valorNegociado"
                      placeholder="Insira um valor"
                      :name="'valorNegociacao' + itemLote.id"
                      :maxLength="18"
                      :required="true"
                      :prefix="prefix"
                      :suffix="suffix"
                      v-validate="'required'"
                      class="alinhar-direita money-input"
                      :showClearButton="false"
                      @click.native.stop
                      :precision="casasDecimais"
                      @blur="valorNegociado = $event"
            />
        </v-chip>

        <span>
            <v-btn flat icon color="success"
                   @click.native.stop="exibirMensagemConfirmacaoAceitar()"
                   class="ml-auto botao-aceitar">
                <v-icon size="20px">fas fa-check-circle</v-icon>
            </v-btn>

            <v-btn flat icon color="error"
                   @click.native.stop="exibirMensagemConfirmacaoRecusar()"
                   class="ml-auto botao-rejeitar">
                <v-icon size="20px">fas fa-times-circle</v-icon>
            </v-btn>
        </span>
    </span>

    <v-chip v-if="itemLote.negociacao && itemLote.negociacao.aceito" color="transparent"
            class="ml-4" style="font-size: 14px" @click.native.stop>

        <v-icon size="20px" color="#4A9246" style="padding-right: 4px">far fa-check-circle</v-icon>
        <strong> Negociado:&nbsp;</strong>
        <span v-if="itemLote.negociacao.valor !== null">
            {{itemLote.negociacao.valor | cdCurrency(prefix, casasDecimais)}}{{suffix}}
        </span>
        <span v-else>&nbsp;-&nbsp;</span>
    </v-chip>

    <mensagem-confirmacao class="mensagem-confirmacao"
                          :exibirMensagem="mostrarMensagemConfirmacao"
                          :titulo="aceitandoOuRecusando === negociacaoOpcoes.aceitar ? 'Aceitar Negociação':'Recusar Negociação'"
                          :textoSecundario="textoMensagemConfirmacao"
                          @confirmado="aceitarRecusarNegociacao()"
                          @recusado="mostrarMensagemConfirmacao = false"/>
    </div>
</template>

<script>
import accounting from 'accounting'
export default {
    name: 'AreaNegociacao',
    props:{
        itemLote:{
            type: Object
        },
        aceitaValorZero:{
            type: Boolean,
            default: null
        },
        casasDecimais:{
            type: Number
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        }
    },
    data(){
        return{
            valorNegociado: this.itemLote.negociacao.valor,
            mostrarMensagemConfirmacao: false,
            aceitandoOuRecusando: null,
            negociacaoOpcoes: Object.freeze({aceitar:'ACEITAR', recusar:'RECUSAR'})
        }
    },
    computed:{
        textoMensagemConfirmacao(){
            const termo = this.criterioJulgamento === 'MENOR_PRECO' ? 'valor' : 'desconto'
            if(this.aceitandoOuRecusando === this.negociacaoOpcoes.aceitar)
                return 'Deseja realmente aceitar a negociação com o '+ termo +' de '+ this.formatarValor(this.valorNegociado) + ' ?'
            return 'Deseja realmente recusar a negociação?'
        },
        formatarValorNegociacao(){
            if(this.criterioJulgamento === 'MAIOR_DESCONTO')
                return `${this.itemLote.negociacao.valor}${this.simboloCriterioJulgamento}`

            return `${this.simboloCriterioJulgamento} ${this.itemLote.negociacao.valor}`
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        }
    },
    methods:{
        async aceitarRecusarNegociacao(){
            this.mostrarMensagemConfirmacao = false

            if(this.aceitandoOuRecusando === this.negociacaoOpcoes.aceitar){
                this.$emit('atualizarValorNegociacao', {valor:this.valorNegociado, itemLote:this.itemLote})
                this.$emit('aceitarNegociacao', {itemLote: this.itemLote, aceito: true})
            }
            if(this.aceitandoOuRecusando === this.negociacaoOpcoes.recusar) {
                this.$emit('aceitarNegociacao', {itemLote: this.itemLote, aceito: false})
            }
        },
        validarValorNegociacao(itemLote){
            if(this.valorNegociado === null)
                throw new Error('É necessário inserir um valor para negociar!')
            if(this.valorNegociado === 0 && !this.aceitaValorZero)
                throw new Error('É necessário inserir um valor maior que zero para negociar!')
            if(this.criterioJulgamento === 'MAIOR_DESCONTO') {
                if (this.valorNegociado < itemLote.valorArrematado)
                    throw new Error('O desconto negociado deve ser maior ao desconto arrematado!')
            }
            else if (this.valorNegociado > itemLote.valorArrematado)
                throw new Error('O valor negociado deve ser inferior ao valor arrematado!')
        },
        exibirMensagemConfirmacaoAceitar(){
            this.validarValorNegociacao(this.itemLote)
            this.aceitandoOuRecusando = this.negociacaoOpcoes.aceitar
            this.mostrarMensagemConfirmacao = true
        },
        exibirMensagemConfirmacaoRecusar(){
            this.aceitandoOuRecusando = this.negociacaoOpcoes.recusar
            this.mostrarMensagemConfirmacao = true
        },
        formatarValor(numero) {
            if (numero !== null && this.criterioJulgamento === 'MENOR_PRECO') {
                return accounting.formatMoney(numero, 'R$ ', this.casasDecimais, '.', ',', '%s%v')
            }
            else if(numero !== null && this.criterioJulgamento === 'MAIOR_DESCONTO')
                return accounting.formatMoney(numero, '%', this.casasDecimais, '.', ',', '%v%s')

            return null
        },
    }
}

</script>

<style lang="stylus">

    .icone-negociacao
        font-size 22px
        margin-bottom -2px
        margin-right 5px

    .icone-mensagem-negociacao
        padding-bottom 2px
        margin 0 2px 0 0

    .negociacao-solicitada
        padding 0
        margin 0
        font-weight bold
        font-size 15x
        color var(--v-primary--text) !important

    .money-chip
        padding 0
        margin 0

    .money-input
        width 120px
        position relative

    .link-icone-mensagem
        width 10px
        padding 0

    .botao-aceitar
        width 25px
        height 25px
        margin 0 0 0 0

    .botao-rejeitar
        width 25px
        height 25px
        margin 0 0 0 0

</style>
